import { Component, Vue, Watch } from 'vue-property-decorator';
import template from './user-profile.vue';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import { User, ModalState, ModalComponents } from '@/definitions';

@Component({
  mixins: [template],
})
export default class UserProfile extends Vue {
  colors: string[] = ['purple', 'green', 'red', 'blue', 'orange', 'pink', 'dark-green', 'yellow'];
  selectedColor: string = '';
  password: string = '';
  newPassword: string = '';
  newPasswordRepeat: string = '';
  errorType: number = 0;
  user: User | undefined;
  languages: string[] = [];
  lang: string = '';
  multipleAdmins: boolean = false;

  @Watch('password')
  @Watch('newPassword')
  @Watch('newPasswordRepeat')
  resetErrorType(password: string) {
    if (password) {
      this.errorType = 0;
    }
  }

  async created() {
    this.languages = this.$i18n.availableLocales;
    this.lang = this.$i18n.locale;
    this.user = { ...this.$Store.state.user };
    this.selectedColor = this.user.color;
    if (this.user.isAdmin) {
        const users = await apiService.getUsers();
      if (users && users.length) {
        this.multipleAdmins = users.filter(u => u.isAdmin).length > 0;
      }
    }
  }

  selectColor(color: string) {
    this.selectedColor = color;
  }

  async saveUser() {
    if (this.user?.firstName && this.user?.lastName) {
      try {
        this.user.language = this.lang;
        await apiService.saveUser({ ...this.user as User, color: this.selectedColor });
        this.$i18n.locale = this.lang;
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.profile.save_success', type: 'success' });
      } catch (e) {
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_error', type: 'danger' });
      }
    }
  }

  async updatePassword() {
    if (!(
      this.newPassword.match(/[a-z]/g) &&
      this.newPassword.match(/[A-Z]/g) &&
      this.newPassword.match(/[0-9]/g) &&
      this.newPassword.match(/[^a-zA-Z\d]/g) &&
      this.newPassword.length >= 8
    )) {
      this.errorType = 3;
    } else if (this.newPassword === this.newPasswordRepeat) {
      try {
        await apiService.updatePassword({ password: this.password, newPassword: this.newPassword });
        this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.profile.password_save_success', type: 'success' });
      } catch (e) {
        this.password = '';
        this.errorType = 1;
      }
    } else {
      this.newPassword = '';
      this.newPasswordRepeat = '';
      this.errorType = 2;
    }
  }

  async deleteAccount(type: string) {
    const modalState: ModalState = {
      component: ModalComponents.REMOVE_USER,
      active: true,
      props: {
        company: this.user?.company,
        type
      }
    }
    this.$Store.dispatch(Action.SHOW_MODAL, modalState);
  }
}